export const scrollToFieldAnexo = (idAnexo, ref, timeout = 0) => {
  if (idAnexo && ref.current) {
    setTimeout(() => {
      ref?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, timeout);
  }
};